import React from "react"
import { Link } from "gatsby"
import { motion } from "framer-motion"

function Blogcards({ thumbnail, title, blog, date }) {
  if (!thumbnail) {
    return null
  }

  return (
    <motion.div
      variants={blogCardsVariants}
      initial="hidden"
      animate="visible"
      whileHover="onHover"
      whileTap="onTap"
      className="col-md-5 col-lg-4 my-3 mx-3 mx-md-auto p-2"
    >
      <Link
        to={`/blogs/${blog}`}
        className="card p-1 blogCard text-decoration-none"
      >
        <img
          src={require(`./../../images/thumbnails/${thumbnail}.png`)}
          alt={title}
          className="img-fluid"
        />
        <div className="mt-2">
          <h6 className="blog-name">{title}</h6>
          {/* <h6 className="text-muted">
            <i className="fas fa-clock mr-1"></i>
            <span>{date}</span>
          </h6> */}
        </div>
      </Link>
    </motion.div>
  )
}

export default Blogcards

const blogCardsVariants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: { delay: 1, duration: 0.5 },
  },
  onHover: {
    scale: 1.05,
  },
  onTap: {
    scale: 0.95,
  },
}
